import { createAsyncThunk } from "@reduxjs/toolkit";
import customFetch from "../../util/config/axiosConfig";
import { getAuthUser } from "../../util/manageAuth";
import { UpdateProfilePayload, UserProfile  } from "../../types/profileType";

export const fetchProfile = createAsyncThunk<
  UserProfile,
  void,
  { rejectValue: string }
>(
  "profile/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const userId = getAuthUser()?.userId;
      if (!userId) throw new Error("User not authenticated");

      const response = await customFetch.get(`/user/${userId}`);

      let payload = response.data;

      if (typeof payload?.data === "string") {
        payload.data = JSON.parse(payload.data);
      }

      return payload.data;

    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Failed to fetch profile"
      );
    }
  }
);

export const updateProfile = createAsyncThunk<
  UserProfile,
  UpdateProfilePayload,
  { rejectValue: string }
>(
  "profile/updateProfile",
  async (formData, thunkAPI) => {
    try {
      const userId = getAuthUser()?.userId;

      if (!userId) throw new Error("User not authenticated");

      const response = await customFetch.put(
        `/user/profile/${userId}`,
        formData
      );

      let payload = response.data;

      if (typeof payload?.data === "string") {
        payload.data = JSON.parse(payload.data);
      }

      return payload.data;

    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.message || "Failed to update profile"
      );
    }
  }
);